/**
 * PlantaMark
 *
 * The Planta wordmark glyph. Single shared SVG, filled with `currentColor`
 * so consumers control the colour via Tailwind text utilities — pair with
 * `text-foreground` (or any text-* utility) on the parent. Used by the
 * editorial LoginPage hero and the AdminSidebar brand block.
 */

import type React from "react";

export interface PlantaMarkProps {
  readonly className?: string;
}

export function PlantaMark({ className }: PlantaMarkProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21 20"
      aria-hidden="true"
      className={className}
    >
      <path
        d="M12.213 0C14.776 0 16.857 2.073 16.857 4.634C16.857 7.197 14.776 9.27 12.213 9.27H2.164V7.371H12.213C13.731 7.37 14.953 6.143 14.953 4.634C14.953 3.126 13.731 1.901 12.213 1.9C10.694 1.9 9.46 3.131 9.46 4.634V6.432H7.561V4.634C7.561 2.07 9.654 0 12.213 0ZM9.272 15.108C9.251 17.65 7.187 19.706 4.638 19.706C2.077 19.706 0 17.633 0 15.071C0 12.51 2.077 10.434 4.638 10.434H6.421V12.337H4.638C3.124 12.337 1.901 13.563 1.901 15.071C1.902 16.581 3.125 17.808 4.638 17.808C6.149 17.808 7.371 16.585 7.371 15.072V10.166H9.272V15.108ZM14.379 12.337H10.225V10.434H14.379V12.337Z"
        fill="currentColor"
      />
    </svg>
  );
}
